import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import { useSelector } from "react-redux";
import { selectUser } from "../features/auth/authSlice";
import { calculateDealerPrice, calculateUpdatedDiscountPercentage, formatWithCommasWithDecimal } from "../utils/utils";

function PriceBreakDown({
  selectedProduct,
  product,
}) {
  const userDetail = useSelector(selectUser);
  const calculateGST = (price, gst) => (price * gst) / 100;


  return (
    <div className="w-full bg-[#f4fafd] flex flex-col items-start justify-start my-3 pb-2 rounded-md shadow-sm">
      {/* ✅ Price Breakdown */}
      <div className="w-full flex flex-col border-t border-gray-200">
        {[
          { label: "MRP", value: selectedProduct[0]?.MRP_price },
          {
            label: "Sale Price",
            value: calculateDealerPrice(
              parseInt(selectedProduct[0]?.MRP_price),
              parseInt(selectedProduct[0]?.NDP_Price),
              product?.GST
            ),
          },
          {
            label: "NET OFF",
            value:
              calculateUpdatedDiscountPercentage(
                selectedProduct[0]?.MRP_price,
                parseInt(selectedProduct[0]?.NDP_Price),
                product?.GST
              ) + "%",
          },
          {
            label: "GST",
            value:
              "₹" +
              formatWithCommasWithDecimal(
                calculateGST(
                  parseInt(selectedProduct[0]?.NDP_Price),
                  product?.GST
                )
              ) +
              ` (${product?.GST}%)`,
          },
          {
            label: "Shipping To",
            value:
              userDetail?.UserID && userDetail?.location
                ? `${userDetail?.location} - ${userDetail?.pin_code}`
                : "...",
          },
        ].map(
          (item, idx) =>
            item.value && (
              <div
                key={idx}
                className="flex items-center justify-between px-4 py-2 text-sm text-gray-800 font-semibold"
              >
                <p>{item.label}</p>
                <span>{item.value}</span>
              </div>
            )
        )}
      </div>

      {/* ✅ Delivery Estimate */}
      <div className="w-full flex items-center justify-center my-3 text-green text-sm font-semibold">
        <AirplanemodeActiveIcon className="text-lg mr-2" />
        Estimated delivery:{" "}
        {new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString(
          "en-US",
          {
            day: "numeric",
            month: "long",
            year: "numeric",
          }
        )}
      </div>

    </div>
  );
}


export default PriceBreakDown;
